import { toUnixTimestamp } from '@/ui/i18n/i18n';
import { IssueDetail, IssuePhoto, IssueSendable } from '@/entities/issue/v2';
import { IssueRecordEditable } from '@/ui/pages/issue/issueTypes';

export function intoEditable(issueRecord: IssueDetail): IssueRecordEditable {
  return {
    ...issueRecord.data,
    // This needs to be added as for some reason the backend is sending the `photos`
    // with a `uuid` set to `null` instead of string. As soon as the cause for this
    // is discovered this @ts-ignore should be removed and the codec returned
    // to its original form (uuid: t.string)
    // @ts-ignore
    photos: issueRecord.data.photos,
    assignedGroups: issueRecord.data.assignedGroups.map(group => `group_${group.id}`),
    assignees: issueRecord.data.assignees.map(a => `user_${a.id}`),
    associateAssignees: issueRecord.data.associateAssignees.map(a => a.email),
    entityItem: issueRecord.data.entityItem ? issueRecord.data.entityItem.id : null,
  };
}

export function intoSendable(
  issueRecordEditable: IssueRecordEditable,
  timezone: string | null = null,
): IssueSendable {
  return {
    ...issueRecordEditable,
    deadline: issueRecordEditable.deadline ? toUnixTimestamp(issueRecordEditable.deadline.getTime()) : null,
    //because BE need it
    photos: issueRecordEditable.photos ? issueRecordEditable.photos.map(p => {
      p.height = p.height ?? 0;
      p.width = p.width ?? 0;
      return p as IssuePhoto;
    }) : [],
    timezone,
  };
}
